var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconUsa(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 63,
    height: 64,
    viewBox: "0 0 63 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#281978;}.b{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-217 -636)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 27.559,
    height: 21.5,
    rx: 1,
    transform: "translate(220.441 640)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 33.559,
    height: 2.5,
    rx: 1,
    transform: "translate(246.441 640)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 1.5,
    height: 1.5,
    transform: "translate(222.75 641.189) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 1.5,
    height: 1.5,
    transform: "translate(222.75 645.475) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 1.5,
    height: 1.5,
    transform: "translate(222.75 649.761) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 1.5,
    height: 1.5,
    transform: "translate(222.75 654.189) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 1.5,
    height: 1.5,
    transform: "translate(222.75 658.189) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 1.5,
    height: 1.5,
    transform: "translate(227.272 641.189) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 1.5,
    height: 1.5,
    transform: "translate(227.272 645.475) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 1.5,
    height: 1.5,
    transform: "translate(227.272 649.761) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 1.5,
    height: 1.5,
    transform: "translate(227.272 654.189) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 1.5,
    height: 1.5,
    transform: "translate(227.272 658.189) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 1.5,
    height: 1.5,
    transform: "translate(225.099 643.189) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 1.5,
    height: 1.5,
    transform: "translate(225.099 647.618) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 1.5,
    height: 1.5,
    transform: "translate(225.099 651.904) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 1.5,
    height: 1.5,
    transform: "translate(225.099 656.189) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 1.5,
    height: 1.5,
    transform: "translate(231.795 641.189) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 1.5,
    height: 1.5,
    transform: "translate(231.795 645.475) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 1.5,
    height: 1.5,
    transform: "translate(231.795 649.761) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 1.5,
    height: 1.5,
    transform: "translate(231.795 654.189) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 1.5,
    height: 1.5,
    transform: "translate(231.795 658.189) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 1.5,
    height: 1.5,
    transform: "translate(229.622 643.189) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 1.5,
    height: 1.5,
    transform: "translate(229.622 647.618) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 1.5,
    height: 1.5,
    transform: "translate(229.622 651.904) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 1.5,
    height: 1.5,
    transform: "translate(229.622 656.189) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 1.5,
    height: 1.5,
    transform: "translate(236.317 641.189) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 1.5,
    height: 1.5,
    transform: "translate(236.317 645.475) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 1.5,
    height: 1.5,
    transform: "translate(236.317 649.761) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 1.5,
    height: 1.5,
    transform: "translate(236.317 654.189) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 1.5,
    height: 1.5,
    transform: "translate(236.317 658.189) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 1.5,
    height: 1.5,
    transform: "translate(234.144 643.189) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 1.5,
    height: 1.5,
    transform: "translate(234.144 647.618) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 1.5,
    height: 1.5,
    transform: "translate(234.144 651.904) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 1.5,
    height: 1.5,
    transform: "translate(234.144 656.189) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 1.5,
    height: 1.5,
    transform: "translate(240.84 641.189) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 1.5,
    height: 1.5,
    transform: "translate(240.84 645.475) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 1.5,
    height: 1.5,
    transform: "translate(240.84 649.761) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 1.5,
    height: 1.5,
    transform: "translate(240.84 654.189) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 1.5,
    height: 1.5,
    transform: "translate(240.84 658.189) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 1.5,
    height: 1.5,
    transform: "translate(238.667 643.189) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 1.5,
    height: 1.5,
    transform: "translate(238.667 647.618) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 1.5,
    height: 1.5,
    transform: "translate(238.667 651.904) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 1.5,
    height: 1.5,
    transform: "translate(238.667 656.189) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 1.5,
    height: 1.5,
    transform: "translate(245.362 641.189) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 1.5,
    height: 1.5,
    transform: "translate(245.362 645.475) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 1.5,
    height: 1.5,
    transform: "translate(245.362 649.761) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 1.5,
    height: 1.5,
    transform: "translate(245.362 654.189) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 1.5,
    height: 1.5,
    transform: "translate(245.362 658.189) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 1.5,
    height: 1.5,
    transform: "translate(243.189 643.189) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 1.5,
    height: 1.5,
    transform: "translate(243.189 647.618) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 1.5,
    height: 1.5,
    transform: "translate(243.189 651.904) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 1.5,
    height: 1.5,
    transform: "translate(243.189 656.189) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 33.559,
    height: 2.5,
    rx: 1,
    transform: "translate(246.441 659)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 33.559,
    height: 2.5,
    rx: 1,
    transform: "translate(246.441 646)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 60,
    height: 2.5,
    rx: 1,
    transform: "translate(220 665)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 33.559,
    height: 2.5,
    rx: 1,
    transform: "translate(246.441 653)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 60,
    height: 2.5,
    rx: 1,
    transform: "translate(220 671)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 60,
    height: 2.5,
    rx: 1,
    transform: "translate(220 677)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 2.5,
    height: 64,
    rx: 1.25,
    transform: "translate(217 636)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUsa);
export default __webpack_public_path__ + "static/media/icon-usa.ec8571668e0adec2fe592469a3791e31.svg";
export { ForwardRef as ReactComponent };